function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.44941 4.04105C1.05618 4.45975 0.833984 5.05476 0.833984 5.80048V12.261C0.833984 13.8268 1.81358 14.8334 3.29919 14.8334H4.37609V16.7478C4.37609 17.1557 4.59018 17.4189 4.95347 17.4189C5.21296 17.4189 5.39461 17.2939 5.69952 17.0044L7.58735 15.2215C7.22405 14.9255 6.92563 14.4584 6.92563 13.386V9.51727L1.44941 4.04105Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.8144 10.406V13.1755C7.8144 14.7347 8.72264 15.7413 10.2731 15.7413H12.3491L14.691 17.9123C14.9959 18.2018 15.1776 18.3334 15.4371 18.3334C15.5325 18.3334 15.6172 18.3154 15.6902 18.2818L7.8144 10.406Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0145 16.8383L7.84832 8.67219C8.02626 7.41362 8.89657 6.70837 10.2731 6.70837H16.7021C18.1877 6.70837 19.1673 7.60311 19.1673 9.17548V13.1755C19.1673 14.7347 18.1877 15.7413 16.7021 15.7413H16.0145V16.8383Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.07212 7.89599L2.58671 3.41059C2.80798 3.3595 3.04625 3.33337 3.29919 3.33337H12.1999C13.6855 3.33337 14.5613 4.20837 14.6586 5.55706L14.6651 5.80706H10.1239C8.53776 5.80706 7.44949 6.56651 7.07212 7.89599Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1.76865 0.833374L19.3733 18.438L18.4894 19.3219L0.884766 1.71726L1.76865 0.833374Z",
  fill: "white"
});

function SvgIconChatHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatHide);
export default __webpack_public_path__ + "static/media/icon-chat-hide.40f540e0.svg";
export { ForwardRef as ReactComponent };